import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { CalendarClock, Search, Building2, KeyRound } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'
import { IndeedFlexAuthStatusBanner } from './shared/components/IndeedFlexAuthStatusBanner'

export const IndeedFlex = () => {
  return (
    <>
      <Header title="Indeed Flex" />
      <IndeedFlexAuthStatusBanner />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.INDEED_FLEX_COMPANIES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <Building2 size={14} />
                  <Text fontSize={2} color="lightText">
                    Companies
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Link WorkWhile companies to Indeed Flex clients and control
                shift creation.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.INDEED_FLEX_SHIFT_ISSUES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <CalendarClock size={14} />
                  <Text fontSize={2} color="lightText">
                    Shift Issues
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Indeed Flex shifts that need manual intervention or linking.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.INDEED_FLEX_JOB_SHIFTS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <Search size={14} />
                  <Text fontSize={2} color="lightText">
                    Job Shifts
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Look up Indeed Flex shifts by client and job ID.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.INDEED_FLEX_OTP}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <KeyRound size={14} />
                  <Text fontSize={2} color="lightText">
                    2FA Code
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Request an Indeed Flex email code and submit it to restore sync.
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
